<template>
  <v-container id="contact-list" class="contact-list" fluid tag="section" style="margin-top: -15px">
    <div class="md-layout">
      <template v-if="errorMessage">
        <v-alert type="error">{{ errorMessage }}</v-alert>
      </template>

      <v-expansion-panels v-model="panel" multiple>
        <v-expansion-panel>
          <v-expansion-panel-content
            class="pa-0 report-achievement"
            v-show="showAchievement"
            transition="fade"
          >
            <keep-alive>
              <TelesalesReport v-if="showAchievement"/>
            </keep-alive>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-expansion-panels
        v-model="viewExpansionPanels"
        multiple
        :style="this.showAchievement ? 'margin-top: 12px' : ''"
      >
        <v-expansion-panel>
          <v-expansion-panel-content class="panel-no-pb contact-filter">
            <v-row :style="isMobile ? 'height: 160px' : 'height: 50px'">
              <v-col cols="12" md="5" class="pb-0 pt-0">
                <div class="text-left mb-1 mt-2">
                  <v-menu offset-y>
                    <template #activator="{ on: onMenu }">
                      <v-tooltip bottom>
                        <template #activator="{ on: onTooltip }">
                          <v-btn
                            min-width="45"
                            style="margin-right: 10px;"
                            class="mb-2"
                            color="info"
                            small
                            v-on="{ ...onMenu, ...onTooltip }"
                          >
                            <v-icon>mdi-gesture-tap</v-icon>
                          </v-btn>
                        </template>

                        <span>Thao tác</span>
                      </v-tooltip>
                    </template>
                    <v-list>
                      <v-list-item
                        v-for="(action, index) in actionList"
                        :key="`${action.id}_${index}`"
                        @click="showModalAction(action.type, action.store)"
                        :style="filterForm.store == 'G' ? (['C', 'G'].includes(action.store) ? 'display: none' : '') :
                          action.store == filterForm.store ? 'display: none' : ''"
                      >
                        <v-list-item-title>
                          {{ action.title }}
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>

                  <template v-if="checkAuthorization('contact_create')">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          min-width="45"
                          v-on="on"
                          small
                          v-if="checkAuthorization('contact_create')"
                          style="margin-right: 10px;"
                          color="primary"
                          dark
                          class="mb-2"
                          @click="clickAddContact"
                        >
                          <v-icon>mdi-plus</v-icon>
                        </v-btn>
                      </template>
                      <span>Thêm mới</span>
                    </v-tooltip>
                  </template>

                  <v-tooltip bottom v-if="checkAuthorization('contact_download')">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        min-width="45"
                        v-on="on"
                        small
                        @click="openModalImportFile"
                        style="margin-right: 10px;"
                        color="success"
                        dark
                        class="mb-2"
                      >
                        <v-icon style="margin-right: 5px;">mdi-folder-upload</v-icon>
                      </v-btn>
                    </template>
                    <span>Upload</span>
                  </v-tooltip>
                  <input
                    style="display: none;"
                    class="file-input"
                    ref="contactFileInput"
                    type="file"
                    @input="showPopup"
                    accept=".xlsx"
                  />

                  <v-menu
                    :internal-activator="true"
                    v-model="filterForm.openRowMenu"
                    content-class="menu__customer--filter no-contain overflow-visible"
                    :close-on-content-click="false"
                    offset-y
                  >
                    <template #activator="{ on: onMenu }">
                      <v-tooltip bottom>
                        <template #activator="{ on: onTooltip }">
                          <v-btn
                            min-width="45"
                            small
                            class="mb-2"
                            dark
                            v-on="{ ...onMenu, ...onTooltip }"
                          >
                            <v-icon>mdi-view-column</v-icon>
                          </v-btn>
                        </template>

                        <span>Cột hiển thị</span>
                      </v-tooltip>
                    </template>
                    <card-row-attribute
                      :filterForm="filterForm"
                      :contactColumns="contactColumns"
                      :rowAttributes="rowAttributes"
                    />
                  </v-menu>

                  <v-tooltip bottom>
                    <template #activator="{ on: onTooltip }">
                      <v-btn
                        min-width="45"
                        @click="showStatusTable()"
                        small
                        color="warning"
                        class="mb-2 ml-2"
                        dark
                        v-on="onTooltip"
                      >
                        <v-icon>mdi-format-align-middle</v-icon>
                      </v-btn>
                    </template>

                    <span>Ẩn/hiện mối quan hệ</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template #activator="{ on: onTooltip }">
                      <v-btn
                        min-width="45"
                        @click="showAchievementTable()"
                        small
                        color="grey"
                        class="mb-2 ml-2"
                        dark
                        v-on="onTooltip"
                      >
                        <v-icon>mdi-arrow-all</v-icon>
                      </v-btn>
                    </template>

                    <span>Ẩn/hiện chỉ số cá nhân</span>
                  </v-tooltip>

                  <template>
                    <v-menu offset-y>
                      <template #activator="{ on: onMenu }">
                        <v-tooltip bottom>
                          <template #activator="{ on: onTooltip }">
                            <v-btn
                              min-width="45"
                              class="ml-2 mb-2"
                              color="secondary"
                              dark
                              v-on="{ ...onMenu, ...onTooltip }"
                              small
                            >
                              <v-icon>mdi-format-align-bottom</v-icon>
                            </v-btn>
                          </template>

                          <span>Số dòng hiển thị</span>
                        </v-tooltip>
                      </template>
                      <v-list class="s-lines-displayed" style="min-width: 100px">
                        <v-list-item
                          class="lines-displayed pa-0"
                          style="cursor: pointer"
                          v-for="(item, index) in items"
                          :key="`${item.id}_${index}`"
                        >
                          <v-list-item-title
                            class="item-lines-displayed"
                            @click="changeLimit(item)"
                          >{{ item }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </template>

                  <v-tooltip bottom v-if="isShowModule">
                    <template #activator="{ on: onTooltip }">
                      <v-btn
                          min-width="45"
                          @click="showModule"
                          small
                          color="#096860"
                          class="mb-2 ml-2"
                          dark
                          v-on="onTooltip"
                      >
                        <v-icon>mdi-view-compact</v-icon>
                      </v-btn>
                    </template>

                    <span>Ẩn/hiện kho tổng</span>
                  </v-tooltip>
                    <v-tooltip bottom v-if="!isShowModule && checkAuthorization('change-bot-call_read')">
                        <template #activator="{ on: onTooltip }">
                            <v-btn
                                    min-width="45"
                                    @click="showModalCampaign"
                                    small
                                    color="#2F80ED"
                                    class="mb-2 ml-2"
                                    dark
                                    v-on="onTooltip"
                            >
                                <v-img width="18"  src="@/assets/campaign.svg" />
                            </v-btn>
                        </template>

                        <span>Tạo chiến dịch tự động</span>
                    </v-tooltip>

                  <v-tooltip v-if="mapContactStatusIdCanCall[this.filterForm.statusIds ? this.filterForm.statusIds[0] : ''] && checkAuthorization('auto-call_read')" bottom>
                    <template #activator="{ on: onTooltip }">
                      <v-btn
                          min-width="45"
                          small
                          @click="openAutoCallPopup"
                          color="#096860"
                          class="mb-2 ml-2"
                          dark
                          v-on="onTooltip"
                      >
                        <v-icon>mdi-phone-forward</v-icon>
                      </v-btn>
                    </template>

                    <span>Auto dial</span>
                  </v-tooltip>
                  <span v-if="isOpenAutoCallPopup" class="auto-call-popup">
                      <v-tooltip bottom>
                          <template #activator="{ on: onTooltip }">
                            <div class="auto-call-button"  style="background: #279201;" v-if="!isAutoCall" @click="startAutoCall" v-on="onTooltip"><v-icon>mdi-phone</v-icon></div>
                            <div class="auto-call-button" style="background: #E23529;" v-else @click="stopAutoCall"><v-icon>mdi-pause</v-icon></div>
                          </template>
                          <span>Call /Pause</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template #activator="{ on: onTooltip }">
                          <div class="auto-call-button" style="background: #254B85;" v-on="onTooltip" @click="resetAutoCall"><v-icon>mdi-reload</v-icon></div>
                        </template>
                        <span>Recall</span>
                      </v-tooltip>
                  </span>
                </div>
              </v-col>
              <!-- <v-col cols="12" md="1"></v-col> -->
              <v-col cols="12" md="1" class="pb-0 pt-0 mobile-hidden">
                <v-autocomplete
                  class="filter-store pt-0"
                  v-model="filterForm.store"
                  :items="storeStocks"
                  item-text="name"
                  item-value="value"
                  @change="changeStoreStock"
                />
              </v-col>

              <v-col cols="12" md="3" class="pb-0 pt-0"
                  :style="isMobile ? 'height: 35px' : ''">
                <filter-form
                  :filter-form="filterForm"
                  :contactStatusList="contactStatusList"
                  :contactSources="contactSources"
                  :users="users"
                  :productGroups="productGroups"
                  :productList="productList"
                  :schoolLevelList="schoolLevelListFilter"
                  :inactiveUsers="inactiveUsers"
                  :provinceList="provinceList"
                />
              </v-col>
              <!-- <v-col cols="12" md="1"></v-col> -->
              <!-- <v-col cols="12" md="3" class="pb-0" v-if="totalItem > limit" style="display: flex; justify-content: flex-end"> -->

              <v-col cols="4" class="pb-0 pt-0 mobile-show">
                <v-autocomplete
                  class="filter-store pt-0"
                  v-model="filterForm.store"
                  :items="storeStocks"
                  item-text="name"
                  item-value="value"
                  @change="changeStoreStock"
                />
              </v-col>

              <v-col :cols="isMobile ? 8 : 12" md="3" class="pb-0"
                  style="display: flex; justify-content: flex-end; padding: 0 12px">
                <div class="text-right mb-1 mt-2">
                  {{showContactsIndex()}}
                  <v-btn
                      small
                      class="pagination-btn-left"
                      @click="function() {currentPage--; pendingPage--}"
                      :disabled="currentPage == 1">
                    <v-icon>mdi-menu-left</v-icon>
                  </v-btn>
                  <v-btn
                      small
                      class="pagination-btn-right"
                      @click="function() {currentPage++; pendingPage++}">
                    <v-icon>mdi-menu-right</v-icon>
                  </v-btn>
                </div>
                  <!-- <v-pagination
                    v-model="currentPage"
                    :length="getTotalItem(totalItem, limit)"
                    class="justify-sm-end c-pagination"
                    prev-icon="mdi-menu-left"
                    next-icon="mdi-menu-right"
                    total-visible="4"
                  /> -->
                <div style="width: 35px">
                  <v-text-field
                    class="pt-0"
                    v-model="pendingPage"
                    min="1"
                    step="1"
                    type="number"
                    @input="applyPendingPage()">
                  </v-text-field>
                </div>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
          <v-expansion-panel-content v-show="showStatus" transition="fade" class="contact-status-table">
            <v-row>
              <v-col cols="12" class="pt-0 pb-0">
                <contact-status-count-table
                  :filterForm="filterForm"
                  :totalContactStatus="totalContactStatus"
                  :typeHeaderContactStatus="typeHeaderContactStatus"
                  :contactStatusList="countContactStatusList"
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
          <v-expansion-panel-content v-show="showModuleTable && isShowModule" transition="fade" class="contact-status-table">
            <v-row>
              <v-col cols="12" class="pt-0 pb-0">
                <contact-module-count-table
                  :filterForm="filterForm"
                  :totalContactModule="totalContactModule"
                  :typeHeaderContactModule="typeHeaderContactModule"
                  :contactModuleList="countContactModuleList"
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
          <v-expansion-panel-content class="s-table-contact">
            <div>
              <contact-table
                :users="users"
                :usersMarketing="usersMarketing"
                :rowAttributes="rowAttributes"
                :filter-form="filterForm"
                :contacts="contacts"
                :contactStatusList="contactStatusList"
                :contactSources="contactSources"
                :currentPage="currentPage"
                :limit="parseInt(limit)"
                :usersContactAdvise="usersContactAdvise"
              />
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
    <modal-change-status
      v-if="filterForm.modalType === 'status'"
      :filter-form="filterForm"
      :contactStatusList="contactStatusList"
      :contacts="contacts"
      :contactsSelected="contactsSelected"
    />
    <modal-change-user
      v-else-if="filterForm.modalType === 'user'"
      :filter-form="filterForm"
      :users="usersContactAdvise"
      :contacts="contacts"
    />
    <ModalProductGroup
      v-else-if="filterForm.modalType === 'productGroup'"
      :filter-form="filterForm"
      :productGroups="productGroups"
      :contacts="contacts"
    />
    <modal-change-schoolLevel
        v-if="filterForm.modalType === 'schoolLevel'"
        :filter-form="filterForm"
        :schoolLevelList="schoolLevelList"
        :contacts="contacts"
    />
    <!-- <modal-change-store
        v-if="filterForm.modalType === 'store'"
        :filter-form="filterForm"
        :storeStocks="storeStocks"
        :contacts="contacts"
    ></modal-change-store> -->
    <modal-change-module
      v-if="filterForm.modalType === 'module'"
      :schoolLevelList="schoolLevelList"
      :contacts="contacts"
      :storeStocks="storeStocks"
      :filter-form="filterForm"
      :users="usersContactAdvise"
    />
    <modal-change-store
        v-if="filterForm.modalType === 'store'"
        :filter-form="filterForm"
        :storeStocks="storeStocks"
        :contacts="contacts"
    ></modal-change-store>
    <modal-change-agency
        v-if="filterForm.modalType === 'agency'"
        :filter-form="filterForm"
        :contacts="contacts"
    ></modal-change-agency>
    <ModalImportFile
        v-if="filterForm.modalType === 'importFile'"
        :filter-form="filterForm"
        @choose-file="chooseFile"
    />
      <ModalChangeCampaign
              v-if="filterForm.modalType === 'campaign'"
              :filter-form="filterForm"
              :module="moduleCRM"
              @closeModal="() => filterForm.modalType = ''"
      />
  </v-container>
</template>

<script>
import FilterForm from './components/FilterForm';
import ContactStatusCountTable from './components/ContactStatusCountTable';
import ContactTable from './components/ContactTable';
import ModalChangeStatus from './components/ModalChangeStatus';
import ModalChangeUser from './components/ModalChangeUser';
import ModalProductGroup from './components/ModalProductGroup';
import CardRowAttribute from './components/CardRowAttribute';
import TelesalesReport from './components/TelesalesReport';
import ModalChangeSchoolLevel from './components/ModalChangeSchoolLevel';
import ModalChangeModule from './components/ModalChangeModule';
import ModalChangeStore from './components/ModalChangeStore';
import ContactModuleCountTable from './components/ContactModuleCountTable';
import ModalChangeAgency from './components/ModalChangeAgency';
import ModalImportFile from './components/ModalImportFile';

import { getContactAttribute } from './contact';
import { mapMutations, mapState  } from 'vuex'

import RepositoryFactory from '../../repositories/RepositoryFactory';
import {
  contactStatus,
  typeContactExpand,
  contactStatusDefaultColor
} from '../../helpers/constants';
import { checkMobile } from '../../helpers/utils'
import UserRepository from "@/repositories/UserRepository";
import moment from "moment";
import TokenService from "@/helpers/token";
import ModalChangeCampaign from "@/pages/contact/components/ModalChangeCampaign.vue";
const ContactRepository = RepositoryFactory.get('contact');
const ContactStatusRepository = RepositoryFactory.get('contact_status');
const ContactSourceRepository = RepositoryFactory.get('contact_source');
const ProductGroupRepository = RepositoryFactory.get('product_group');
const OrganizationMachineRepository = RepositoryFactory.get('organization_machine')
const ProductRepository = RepositoryFactory.get('product');
const SchoolLevelRepository = RepositoryFactory.get('school_level')
const AddressRepository = RepositoryFactory.get('address')
const STATUS_TOKEN_EXPIRED = 402;

export default {
  components: {
    ModalChangeCampaign,
    ContactTable,
    ContactStatusCountTable,
    FilterForm,
    ModalChangeStatus,
    ModalChangeUser,
    CardRowAttribute,
    TelesalesReport,
    ModalProductGroup,
    ModalChangeSchoolLevel,
    ModalChangeModule,
    ModalChangeStore,
    ContactModuleCountTable,
    ModalChangeAgency,
    ModalImportFile,
  },
  data() {
    return {
      contactsClone : [],
      arrayCustomerId:[],
      storeStocks: [
        { value: 'T', name: 'Kho T' },
        { value: 'C', name: 'Kho C' },
        // { value: 'G', name: 'Kho G' },
        { value: 'M', name: 'Kho M' },
        { value: '', name: 'Không xác định kho' }
      ],
      errorMessage: '',
      items: TokenService.getUser().position == 'lead' ? [10, 20, 50, 100, 200, 500] : [10, 20, 50, 100],
      filterForm: {
        statusIds: [],
        years: [],
        userIds: [],
        contactSourceIds: [],
        productGroupIds: [],
        assignedAt: [],
        lastSuccessCallAt: [],
        notCallAt: [],
        appointmentAt: [],
        modalType: '',
        store: 'T',
        childName: '',
        closeMenu: false,
        openRowMenu: false,
        checkboxAll: false,
        openQuickView: false,
        openQuickViewMarketing: false,
        importUpdatedAt: [],
        keyword: '',
        typeNumberOfCall: 'eq',
        numberOfCall: '',
        openStudyResult: false,
        boughtProduct: [],
        unBoughtProduct: [],
        customerResult: [],
        typeOrderTotalPrice: 'eq',
        orderCreatedAt: [],
        expiredDate: [],
        neAssignedAt: [],
        orderTotalPrice: '',
        cumulativePoint: '',
        typeCumulativePoint: 'eq',
        schoolLevelIds: [],
        assignedAtHistory: [],
        orderSuccessDate: [],
        tinhId: '',
        orderStatus: '',
        contactedAt: [],
        isContacted: '',
        typeId: this.$store.state.module.typeId,
        schoolLevelId: this.$store.state.module.schoolLevelId,
        moduleSchoolLevelId: this.$store.state.module.schoolLevelId,
        socialValue:null,
        orderCreatedBy: [],
        appointmentTestTime:[],
        appointmentInterviewTime:[],
        testResultTime:[],
        trialDate:[],
        subjectTest:null,
        inputPointCumulated: null,
        monthPicker: null,
        compare: 'eq',
        birthdayDescription: null,
        huyenId: '',
        schoolName: '',
        activeCodes: '',
        hasActiveCode: null,
        isRegistedCapacity: null,
        tags: [],
        zuid: '',
        statusTrial: [],
        typeNumberOfLearnTrial:'eq',
        numberOfLearnTrial:'',
        segmentId: '',
      },
      currentPage: 1,
      pendingPage: 1,
      limit: 20,
      // totalItem: 0,
      contacts: [],
      loading: true,
      viewExpansionPanels: [0, 1],
      panel: [0, 1],
      typeHeaderContactStatus: [],
      contactStatusList: [],
      countContactStatusList: [],
      totalContactStatus: 0,
      contactSources: [],
      users: [],
      productGroups: [],
      showAchievement: false,
      showStatus: true,
      contactColumns: {},
      rowAttributes: getContactAttribute(),
      isMobile: false,
      productList: [],
      usersMarketing: [],
      listStudyResult: {
        CHAMCHI: 'Chăm chỉ',
        BINHTHUONG: 'Bình thường',
        LUOIHOC: 'Bình thường',
        KHONGHOC: 'Không học',
        PHUCTAP: 'Phức tạp'
      },
      schoolLevelList: [],
      schoolLevelListFilter: [],
      inactiveUsers: [],
      provinceList: [],
      watchModule: '',
      usersContactAdvise: [],
      contactsSelected: [],
      ministries: [
        {
          id: 'root_100000000',
          name: 'Tất cả',
          children: []
        },
        {
          id: -1,
          userId: -1,
          name: 'Không người phụ trách'
        }
      ],
      typeHeaderContactModule: [],
      countContactModuleList: [],
      totalContactModule: 0,
      showModuleTable: true,
      isShowModule: false,
      isOpenAutoCallPopup: false,
      mapContactStatusIdCanCall: {},
      phoneNumberCalled: {},
    };
  },
  computed: {
    moduleCRM() {
     return this.$store.state.module
    },
    ...mapState(['autoCallIndex','isAutoCall']),
    actionList() {
      const actionList = [];
      if (this.checkAuthorization('contact_change_status_read')) {
        actionList.push({ title: 'Chuyển mối quan hệ', type: 'status', store: 'all' });
      }

      if (this.checkAuthorization('change-module-contact_read')) {
        actionList.push({ title: 'Chuyển Loại hình/Ngành/Kho', type: 'module', store: 'all' });
      }

      if (this.checkAuthorization('contact_change_user_read')) {
        actionList.push({ title: 'Chuyển người phụ trách', type: 'user', store: 'all' });
      }
      if (this.checkAuthorization('contact_update')) {
        actionList.push({ title: 'Thêm nhóm sản phẩm', type: 'productGroup', store: 'all' });
        // actionList.push({ title: 'Chuyển nhóm ngành', type: 'schoolLevel', store: 'all' });
      }
      // if (this.checkAuthorization('contact_move_to_cc_read')) {
      //   actionList.push({ title: 'Thu hồi contacts trở lại Kho T', type: 'revoke', store: 'T' });
      //   actionList.push({ title: 'Thu hồi contacts về Kho C', type: 'revoke', store: 'C' });
      //   actionList.push({ title: 'Thu hồi contacts về Kho G', type: 'revoke', store: 'G' });
        // actionList.push({ title: 'Thu hồi contacts về Kho M', type: 'revoke', store: 'M' });
      // }
      // if (this.checkAuthorization('contact_move_to_m_read')) {
      //   actionList.push({ title: 'Thu hồi contacts về Kho M', type: 'revoke', store: 'M' });
      // }
      //   // actionList.push({ title: 'Thu hồi contacts về Kho M', type: 'revoke', store: 'M' });
      // }
        // if (this.checkAuthorization('contact_move_to_m_read')) {
        //   actionList.push({ title: 'Thu hồi contacts về Kho M', type: 'revoke', store: 'M' });
        // }
      if (this.checkAuthorization('contact_change_store_read')) {
        actionList.push({ title: 'Chuyển kho', type: 'store', store: 'all' });
      }
      if (this.checkAuthorization('contact_delete')) {
        actionList.push({ title: 'Xoá', type: 'delete', store: 'all' });
      }
      // if (this.checkAuthorization('contact_change_store_read')) {
      //   actionList.push({ title: 'Chuyển kho', type: 'store', store: 'all' });
      // }
      if (this.checkAuthorization('contact_change_school_level_read')) {
        actionList.push({ title: 'Chuyển nhóm ngành', type: 'schoolLevel', store: 'all' });
      }
      if (this.checkAuthorization('change-contact-agency_read')) {
        actionList.push({ title: 'Chuyển kho Thường / Đại lý', type: 'agency', store: 'all' });
      }
      return actionList;
    },
    statusContactViewAll() {
      return this.checkAuthorization('contact_view_all');
    }
  },
  async created() {
    this.appLoadingData(false)
    // if (this.checkAuthorization('check_store_g_read')) {
    //   this.storeStocks.push({ value: 'G', name: 'Kho G' })
    // }
    // this.storeStocks.push({ value: 'M', name: 'Kho M' })
    if (!_.isEmpty(this.$route.query)) {
      for (let key in this.$route.query) {
        this.filterForm[key] = this.$route.query[key]
      }
    }

    if (this.filterForm.store == 'G') {
      if (!this.checkAuthorization('check_store_g_read')) {
        this.filterForm.store = 'T'
        window.history.pushState({store: 'T'}, "",
          window.location.origin + "/contact/contact-list?store=T")
      }
    }

    if((!this.$store.state.module.typeId && !this.$store.state.module.schoolLevelId)) {
      this.showStatus = false
      this.showModuleTable = true
      this.isShowModule = true
    }

    this.getUsers();
    this.getUsersContactAdvise();
    this.getContactList();
    this.getContactStatusList();
    this.getCountContactStatusList();
    this.getContactSources();
    this.getProductGroups();
    this.getContactColumns();
    this.getProductList();
    this.getUsersMarketing();
    this.getListSchoolLevel();
    this.getListProvince();
    this.getListSchoolLevelFilter()
    // this.getListMinistryTree();
    // this.getCountContactModuleList()

    let check = checkMobile()
    if (check) {
      this.isMobile = true
    }

    Bus.$on('contact-list-filter', filterForm => {
      this.filterForm = filterForm;
      this.filterForm.closeMenu = false;
      // this.currentPage = 1;
      // this.pendingPage = 1;
      this.getContactList();
      this.getCountContactStatusList();
      this.getContactStatusList();
      this.getCountContactModuleList();
    });
    Bus.$on('contact-list-filter-by-contact-status', filterForm => {
      this.filterForm = filterForm;
      this.filterForm.closeMenu = false;
      this.currentPage = 1;
      this.pendingPage = 1
      this.getContactList();
    });
    Bus.$on('contact-status-list', () => {
      this.getContactList();
      this.getCountContactStatusList();
      this.getCountContactModuleList();
    });
    Bus.$on('product-group-list', () => {
      this.getContactList()
      this.getProductGroups()
    });
    Bus.$on('contact-change-row-attribute', cloneRowAttributes => {
      this.rowAttributes = cloneRowAttributes.map(s => ({ ...s }));
    });
    Bus.$on('resume-auto-call', () => {
      this.resumeAutoCall()
    })
    Bus.$on('remove-is-calling-contact',() =>{
      this.removeCallStatus()
    })
    Bus.$on('set-in-call-status', () => {
      this.setInCallStatus()
    })
    Bus.$on('check-retry-call', () => {
      this.checkRetryCall()
    })
    // if((!this.$store.state.module.typeId && !this.$store.state.module.schoolLevelId)) {
    //   this.showStatus = false
    //   this.showModuleTable = true
    //   this.isShowModule = true
    // }
    this.getCountContactModuleList();
    this.watchModule = this.$store.watch(
      (state) => {
        return state.module
      },
      (newVal) => {
        this.filterForm = {
          statusIds: [],
          years: [],
          userIds: [],
          contactSourceIds: [],
          productGroupIds: [],
          assignedAt: [],
          lastSuccessCallAt: [],
          notCallAt: [],
          appointmentAt: [],
          modalType: '',
          store: 'T',
          childName: '',
          closeMenu: false,
          openRowMenu: false,
          checkboxAll: false,
          openQuickView: false,
          openQuickViewMarketing: false,
          importUpdatedAt: [],
          keyword: '',
          typeNumberOfCall: 'eq',
          numberOfCall: '',
          openStudyResult: false,
          boughtProduct: [],
          unBoughtProduct: [],
          customerResult: [],
          typeOrderTotalPrice: 'eq',
          orderCreatedAt: [],
          expiredDate: [],
          neAssignedAt: [],
          orderTotalPrice: '',
          cumulativePoint: '',
          typeCumulativePoint: 'eq',
          schoolLevelIds: [],
          assignedAtHistory: [],
          orderSuccessDate: [],
          tinhId: '',
          orderStatus: '',
          contactedAt: [],
          isContacted: '',
          typeId: this.$store.state.module.typeId,
          schoolLevelId: this.$store.state.module.schoolLevelId,
          moduleSchoolLevelId: this.$store.state.module.schoolLevelId,
          socialValue:null,
          orderCreatedBy: [],
          subjectId:null,
          trialDate:[],
          inputPointCumulated: null,
          monthPicker: null,
          compare: 'eq',
          huyenId: '',
          schoolName: '',
          isRegistedCapacity: null,
          tags: [],
          statusTrial: [],
          typeNumberOfLearnTrial: 'eq',
          numberOfLearnTrial:'',
          segmentId: '',
        }
        this.getUsers()
        this.getProductGroups()
        this.getUsersContactAdvise()
        if((!this.$store.state.module.typeId && !this.$store.state.module.schoolLevelId)) {
          this.showStatus = false
          this.showModuleTable = true
          this.isShowModule = true
          this.typeHeaderContactStatus = []
        } else {
          this.showStatus = true;
          this.showModuleTable = true;
          this.isShowModule = false;
        }
        Bus.$emit('contact-list-filter', this.filterForm)
      },
      {
        deep: true
      }
    )
  },
  async updated() {
    setTimeout(() => {
      this.getStyleTable();
    }, 300);
  },
  beforeDestroy() {
    Bus.$off('contact-list-filter');
    Bus.$off('contact-status-list');
    Bus.$off('contact-change-row-attribute');
    Bus.$off('resume-auto-call');
    Bus.$off('remove-is-calling-contact');
    Bus.$off('set-in-call-status');
    Bus.$off('check-retry-call');

    this.watchModule()
  },
  methods: {
    ...mapMutations(['SET_AUTO_CALL_STATE', 'SET_AUTO_CALL_INDEX', 'SET_LIST_CONTACT']),
    openAutoCallPopup(){
      this.isOpenAutoCallPopup = !this.isOpenAutoCallPopup
    },
    resetAutoCall() {
      this.SET_AUTO_CALL_STATE(false);
      this.stopAutoCall();
      this.SET_AUTO_CALL_INDEX(0);
      this.phoneNumberCalled = {};
      if(this.showStatus) {
        this.getCountContactStatusList();
      }
      this.startAutoCall()
    },
    resumeAutoCall() {
      if (!this.contacts[this.autoCallIndex]){
        this.removeCallStatus()
        this.SET_AUTO_CALL_INDEX(0);
        this.$swal({
          title: `Bạn đã gọi tự động hết ${this.contacts.length} contacts `,
          confirmButtonText: 'GỌI TIẾP',
          showCancelButton: true,
          cancelButtonText: 'DỪNG',
        }).then((res) => {
          if (res.value) {
            if (this.contacts.length >= this.limit){
              this.pendingPage = this.pendingPage + 1;
              this.currentPage = this.pendingPage;
              this.startAutoCall();
            }else{
              this.SET_AUTO_CALL_STATE(false);
              this.stopAutoCall();
            }
          }
          this.contacts = _.cloneDeep(this.contactsClone)
        });
        return;
      }
      if (!_.isEmpty(this.phoneNumberCalled)){
        for (let i = 0; i < this.contacts.length; i++) {
          if (!this.phoneNumberCalled[this.contacts[i].mobile]){
            this.SET_AUTO_CALL_INDEX(i);
            break;
          }
        }
      }
      this.removeCallStatus()
      this.setCallingStatus()
      let contact = this.contacts[this.autoCallIndex]
      let user = TokenService.getUser()
      if (user.ext) {
        let data = {
          mobile: contact.mobile,
          showCreateAppointment: false,
          contactId: contact.id,
          callcenter_id: user.callcenter_id,
          mainId: contact.mainId,
          mainMobile: contact.phoneRelated[0],
          store: this.filterForm.store,
          contactCode: contact.code,
        }
        this.phoneNumberCalled[contact.mobile] = true;
        contact.timesCall++;
        Bus.$emit('voice-call-show-popup', data)
        this.SET_AUTO_CALL_INDEX(this.autoCallIndex + 1)
      } else {
        this.$swal({
          title: 'Lỗi!',
          text: 'Chưa có máy lẻ. Vui lòng liên hệ Admin.'
        })
      }
    },
    setInCallStatus(){
      if (this.contacts && this.contacts[this.autoCallIndex - 1]){
        this.contacts[this.autoCallIndex - 1].callingStatus = 'in-call';
      }
    },
    setCallingStatus(){
      if (this.contacts && this.contacts[this.autoCallIndex]){
        this.contacts[this.autoCallIndex].callingStatus = 'calling';
        Bus.$emit('scroll-to-contact-row-index');
      }
    },
    removeCallStatus(){
      if (this.contacts && this.contacts[this.autoCallIndex - 1]){
        this.contacts[this.autoCallIndex - 1].callingStatus = '';
      }
    },
    checkRetryCall(){
     let contact = this.contacts[this.autoCallIndex - 1]
      if(contact && contact.timesCall < 2){
        this.SET_AUTO_CALL_INDEX(this.autoCallIndex -1) 
        this.phoneNumberCalled[contact.mobile] = false;
      }
    },
    async startAutoCall(){
      this.SET_AUTO_CALL_STATE(true)
      if (this.autoCallIndex > 0){
        this.resumeAutoCall()
        return
      }
      // await this.changeLimit(50)
      await this.getContactList();
      if (this.contacts && this.contacts.length < 1){
        // TODO reset call
        this.SET_AUTO_CALL_STATE(false);
        this.stopAutoCall();
        this.SET_AUTO_CALL_INDEX(0);
        return
      }
      this.SET_LIST_CONTACT(this.contacts)
      if (!this.contacts[this.autoCallIndex]){
        return
      }
      this.setCallingStatus()
      let contact = this.contacts[this.autoCallIndex]
      let user = TokenService.getUser()
      if (user.ext) {
        let data = {
          mobile: contact.mobile,
          showCreateAppointment: false,
          contactId: contact.id,
          callcenter_id: user.callcenter_id,
          mainId: contact.mainId,
          mainMobile: contact.phoneRelated[0],
          store: this.filterForm.store,
          contactCode: contact.code,
        }
        this.phoneNumberCalled[contact.mobile] = true;
        contact.timesCall++;
        Bus.$emit('voice-call-show-popup', data)
        let nextIndex = this.autoCallIndex + 1
        this.SET_AUTO_CALL_INDEX(nextIndex)
      } else {
        this.$swal({
          title: 'Lỗi!',
          text: 'Chưa có máy lẻ. Vui lòng liên hệ Admin.'
        })
      }
    },
    stopAutoCall() {
      this.removeCallStatus()
      Bus.$emit('stop-auto-call')
    },
    getStyleTable() {
      let heightFilter = document.querySelector('.contact-filter')
        ? document.querySelector('.contact-filter').clientHeight
        : 0;
      let heightReport = document.querySelector('.report-achievement')
        ? document.querySelector('.report-achievement').clientHeight
        : 0;
      let heightStatus = document.querySelector('.contact-status-table')
        ? document.querySelector('.contact-status-table').clientHeight
        : 0;
      let totalHeader =
        heightFilter + heightReport + heightStatus + 45 + 'px';
      let heightTable = document.querySelector('.contact-table');
      if(heightTable) {
        if (this.contacts.length === 0) {
          heightTable.style.height = `auto`;
        } else {
          heightTable.style.height = `calc(100vh - ${totalHeader})`;
        }
      }
    },
    async getContactColumns() {
      const response = await ContactRepository.getContactColumns();
      if (response.success) {
        this.contactColumns = _.get(response, 'data', {});
        const rowAttributes = this.rowAttributes.map(s => ({ ...s }));
        const oldDataColumns = rowAttributes.filter(element => element.object)
        const newDataColumns = _.flatten(Object.values(this.contactColumns).map(e => {
          return e.map(d => d )
        }))

        // Get attributes need remove
        const columnNewData = newDataColumns.map(e => e.id)
        const columnNeedRemove = _.compact(oldDataColumns.map(old => {
          if(!columnNewData.includes(old.name)) {
            return old
          }
        }))

        // Remove Old row attributes
        let rowAttributesModified = rowAttributes
        columnNeedRemove.forEach(c => {
          rowAttributesModified = rowAttributesModified.filter(e => e.name !== c.name)
        })

        Object.keys(this.contactColumns).forEach(objectValue => {
          let arrayMerge = this.contactColumns[objectValue].map(
            dataAttribute => {
              // Check attributes new
              if (oldDataColumns.filter(e => e.name == dataAttribute.id).length == 0) {
                return {
                  name: dataAttribute.id,
                  title: dataAttribute.description,
                  value: false,
                  show: false,
                  object: dataAttribute.object
                };
              }
            }
          );

          let nameAttribute = 'user';
          if (objectValue === 'parent') {
            nameAttribute = 'contactSources';
          }
          if (objectValue === 'child') {
            nameAttribute = 'email';
          }
          let index = rowAttributesModified.findIndex(
            dataAttribute => dataAttribute.name === nameAttribute
          );

          arrayMerge = _.compact(arrayMerge)
          if(arrayMerge.length != 0) {
            rowAttributesModified.splice(index, 0, ...arrayMerge);
          }
        });
        this.rowAttributes = rowAttributesModified.map(s => ({ ...s }));
      } else {
        this.contactColumns = {};
      }
    },
    openModalImportFile(){
      this.filterForm.modalType = 'importFile';
    },
    showModalCampaign() {
      this.filterForm.modalType = 'campaign';
    },
    chooseFile() {
      this.$refs.contactFileInput.click();
    },
    async changeLimit(limit) {
      this.limit = limit;
    },
    showAchievementTable() {
      this.showAchievement = !this.showAchievement;
    },

    showStatusTable() {
      this.showStatus = !this.showStatus;
      if(this.isShowModule && this.showModuleTable) {
        this.showModuleTable = false
      }
      if(this.showStatus && _.isEmpty(this.typeHeaderContactStatus)) {
        this.getCountContactStatusList();
      }
    },
    showPopup() {
      this.$swal({
        title: 'Bạn chắc chắn muốn up contact vào crm ?',
        confirmButtonText: 'Tiếp tục',
        showCancelButton: true,
        cancelButtonText: 'Hủy',
        confirmButtonColor: '#0C8218',
        cancelButtonColor: '#848484',
      }).then(async (res) => {
        if(res.value) {
          await this.onSelectContactFile();
        }
        else{
          this.$refs.contactFileInput.value = '';
        }
      })
    },
    async onSelectContactFile() {
      // const loader = this.$loading.show();
      this.appLoadingData(true)
      const input = this.$refs.contactFileInput;
      const files = input.files;
      if (files && files[0]) {
        const contactFile = files[0];
        const uploadResponse = await ContactRepository.uploadContact(
          contactFile,
          _.get(this.filterForm, 'store', 'T')
        );
        this.appLoadingData(false)
        // loader.hide();
        this.$refs.contactFileInput.value = '';
        if (_.get(uploadResponse, 'success', false)) {
          this.$swal({
            title: 'Dữ liệu đang được xử lý, sẽ thông báo sau khi kết thúc!'
          });
        } else {
          this.$swal({
            type: 'error',
            title: 'Lỗi !',
            text: _.get(uploadResponse, 'message', '')
          });
        }
      }
    },
    changeStoreStock() {
      window.history.pushState({store: this.filterForm.store}, "",
        window.location.origin + "/contact/contact-list?store=" + this.filterForm.store)
      this.filterForm.statusIds = [];
      this.getContactList();
      this.getContactStatusList();
      this.getCountContactStatusList();
      this.getCountContactModuleList();
    },
    async getProductGroups() {
      const respond = await ProductGroupRepository.list({
        limit: 1000,
        status: 'active',
        schoolLevelId: this.$store.state.module.schoolLevelId,
        typeId: this.$store.state.module.typeId
      });
      if (_.get(respond, 'success', false)) {
        this.productGroups = _.get(respond, 'data', []);
        this.productGroups.unshift({
          name: 'Không có nhóm sản phẩm',
          id: -1
        })
      } else {
        this.productGroups = [];
      }
    },
    async getContactSources() {
      const respond = await ContactSourceRepository.list({ limit: 100 });
      if (_.get(respond, 'success', false)) {
        this.contactSources = _.get(respond, 'data', []);
        this.contactSources.unshift({
          name: 'Không có nguồn khách hàng',
          id: -1
        })
      } else {
        this.contactSources = [];
      }
    },
    async getUsers() {
        const res = await OrganizationMachineRepository.listUser({
          schoolLevelId: this.$store.state.module.schoolLevelId,
          typeId: this.$store.state.module.typeId
        })

        if (res.success) {
          let listUsers = _.get(res, 'data', [])
          const groupUsers = [];
          listUsers.forEach(ministry => {
            const { users = [] } = ministry;
            if (users.length) {
              groupUsers.push({
                header: ministry.name,
                name: _.get(ministry, 'name'),
                ministryId: ministry.id,
              });
              users.forEach(user => {
                groupUsers.push({
                  fullName: _.get(user, 'fullName'),
                  group: _.get(ministry, 'name'),
                  id: user.id,
                  avatar: _.get(user, 'avatar.filePath'),
                  ministryId: ministry.id,
                });
              });
            }
          });
          this.users = groupUsers;
        } else {
          this.$swal({
            title: 'Lỗi!',
            text: _.get(res, 'message', '')
          })
        }
    },
    async getUsersContactAdvise() {
      // const res = await OrganizationMachineRepository.listUserContactAdvise({
      //   schoolLevelId: this.$store.state.module.schoolLevelId,
      //   typeId: this.$store.state.module.typeId
      // })

      // Danh sách user theo bộ phận cấp 3
      const res = await OrganizationMachineRepository.listUserContactAdviseByLevel({
        schoolLevelId: this.$store.state.module.schoolLevelId,
        typeId: this.$store.state.module.typeId,
        level: 3
      })

      if (res.success) {
        let listUsers = _.get(res, 'data', [])
        const groupUsers = [];
        listUsers.forEach(ministry => {
          const { users = [] } = ministry;
          if (users.length) {
            groupUsers.push({
              header: ministry.name,
              name: _.get(ministry, 'name'),
              ministryId: ministry.id,
            });
            users.forEach(user => {
              groupUsers.push({
                fullName: _.get(user, 'fullName'),
                group: _.get(ministry, 'name'),
                id: user.id,
                avatar: _.get(user, 'avatar.filePath'),
                ministryId: ministry.id,
              });
            });
          }
        });
        this.usersContactAdvise = groupUsers;
      } else {
        this.$swal({
          title: 'Lỗi!',
          text: _.get(res, 'message', '')
        })
      }
    },
    async getUsersMarketing() {
      // const loader = this.$loading.show();
      this.appLoadingData(true)
      const respond = await UserRepository.listMarketing({
        type: 'mkt',
        // keyword: 'full name'
      });
      // loader.hide();
      this.appLoadingData(false)
      if (_.get(respond, 'success', false)) {
        this.usersMarketing = _.get(respond, 'data', [])
        // this.usersMarketing.push(
        //     {
        //       fullName: "data test",
        //       id: 132
        //     },
        //     {
        //       fullName: "data test 3",
        //       id: 133
        //     },
        //     {
        //       fullName: "data test 4",
        //       id: 134
        //     }
        // )

      } else {
        this.usersMarketing = [];
      }
    },
    showModalAction(modalType, store = 'all') {
      const changeContactList = this.contacts.filter(
        contact => contact.checkbox
      );
      this.contactsSelected = _.cloneDeep(changeContactList)
      const checkContactList = []
      changeContactList.forEach(contact => {
        if (contact.contactType == 'sub') {
          checkContactList.push(contact.mobile)
        }
      })
      if (checkContactList.length > 0) {
        return this.$swal({
          title: 'Lỗi !',
          text: 'Contact ' + checkContactList.join(", ") + " là contact phụ."
        })
      }
      if (changeContactList.length === 0) {
        return this.$swal({
          title: 'Lỗi !',
          text: 'Vui lòng chọn khách hàng !!!'
        });
      }
      if (modalType === 'delete') {
        return this.deleteContacts(changeContactList);
      }
      if (modalType === 'revoke') {
        return this.$swal({
          title: 'Bạn muốn thu hồi các contact này',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Đồng ý',
          closeOnConfirm: false,
          cancelButtonText: 'Huỷ Bỏ'
        }).then(async result => {
          if (result.value) {
            return this.revokeContacts(changeContactList, store);
          }
        });
      }

      if (modalType === 'user' && changeContactList.length > 5) {
        return this.$swal({
          title: 'Nếu bạn muốn thu hồi contact, hãy thực hiện thao tác thu hồi trước!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'OK',
          closeOnConfirm: false,
          cancelButtonText: 'Không'
        }).then(async result => {
          if (!result.value) {
            return this.filterForm.modalType = modalType;
          }
        });
      }

      // Check contact cùng module
      if (modalType === 'status') {
        for(let j  = 1; j < changeContactList.length; j++) {
          if (changeContactList[j].typeId !== changeContactList[0].typeId
              || changeContactList[j].schoolLevelId !== changeContactList[0].schoolLevelId) {
            return this.$swal({
              title: 'Lỗi !',
              text: 'Vui lòng chọn các contact có cùng Module !!!'
            });
          }
        }
      }


      this.filterForm.modalType = modalType;
    },
    async revokeContacts(changeContactList, store) {
      let statusId = 0
      if (store == 'C') {
        statusId = contactStatus.CO
      } else if (store == 'T') {
        statusId = contactStatus.T0
      } else if (store == 'G') {
        statusId = contactStatus.G0
      } else if (store == 'M') {
        statusId = contactStatus.M0
      }
      const dataUpdate = changeContactList.map(contact => ({
        contactId: contact.id,
        statusId,
      }));
      // this.loading = this.$loading.show();
      this.appLoadingData(true)
      const response = await ContactRepository.updateContactStatus(dataUpdate);
      // this.loading.hide();
      this.appLoadingData(false)
      if (response.error) {
        this.errorMessage = _.get(response, 'message', '');
        return;
      }
      this.getContactList();
      this.getCountContactStatusList();
      this.getCountContactModuleList();
    },
    async deleteContacts(changeContactList) {
      // const contactStatusNew = changeContactList.find(
      //   contact => (_.get(contact, 'contactStatus.type') !== 'T0' && contact.statusId !== contactStatus.NEW) || _.get(contact, 'historyOrder', 'Không') !== 'Không'
      // );
      // if (contactStatusNew) {
      //   return this.$swal({
      //     type: 'error',
      //     title: 'Lỗi !',
      //     text: 'Chỉ được phép xoá các contact ở trạng thái T0 hoặc T1 NEW và không có đơn hàng'
      //   });
      // }
      return this.$swal({
        title: 'Bạn muốn xoá các contacts này',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Đồng ý',
        closeOnConfirm: false,
        cancelButtonText: 'Huỷ Bỏ'
      }).then(async result => {
        if (!result.value) {
          return;
        }
        const dataUpdate = changeContactList.map(contact => contact.id);
        // this.loading = this.$loading.show();
        this.appLoadingData(true)
        const response = await ContactRepository.deleteContacts(dataUpdate);
        let contactDeleteErrors = _.get(response, 'data', []).filter(ele => ele.error)
        // this.loading.hide();
        this.appLoadingData(false)
        if (contactDeleteErrors.length) {
          this.$swal({
            type: 'error',
            title: 'Lỗi !',
            text: _.get(contactDeleteErrors[0], 'message', '')
          });
          return;
        }
        this.$swal({
          title: 'Xoá các contact thành công !!!',
          confirmButtonText: 'Đồng ý'
        }).then(() => {
          this.getContactList();
          this.getCountContactStatusList();
          this.getCountContactModuleList();
        });
      });
    },
    clickAddContact() {
      this.$router.push({
        name: 'ContactCreate'
      });
    },
    async getContactStatusList() {
      // const loading = this.$loading.show();
      Bus.$emit('app-loading, true')
      const response = await ContactStatusRepository.list({
        store: this.filterForm.store,
        typeId: this.$store.state.module.typeId,
        schoolLevelId: this.$store.state.module.schoolLevelId
      });
      // loading.hide();
      this.appLoadingData(false)
      if (response.success) {
        const contactStatusList = [];
        _.get(response, 'data', []).forEach(contactStatus => {
          _.get(contactStatus, 'data', []).forEach(data => {
            contactStatusList.push({
              type: contactStatus.type,
              id: _.get(data, 'id', 0),
              name: _.get(data, 'name', 0),
              color:
                _.get(data, 'color', contactStatusDefaultColor) ||
                contactStatusDefaultColor
            });
          });
        });
        this.contactStatusList = contactStatusList;
      } else {
        this.contactStatusList = [];
      }
    },
    async getCountContactStatusList() {
      // const loading = this.$loading.show();
      if (!this.showStatus) {
        this.typeHeaderContactStatus = []
        return
      }
      this.appLoadingData(true)
      let filterForm = _.cloneDeep(this.filterForm)
      const params = {
        limit: this.limit,
        page: this.currentPage - 1,
        keyword: this.filterForm.keyword,
        years: this.filterForm.years.filter(Boolean),
        // userIds: filterForm.userIds.filter(Boolean),
        userIds: filterForm.userIds.filter(userItem => userItem.hasOwnProperty('userId')).map(itemMap => itemMap.userId),
        contactSourceIds: this.filterForm.contactSourceIds.filter(Boolean),
        productGroupIds: this.filterForm.productGroupIds.filter(Boolean),
        assignedAt: this.filterForm.assignedAt.filter(Boolean),
        lastSuccessCallAt: this.filterForm.lastSuccessCallAt.filter(Boolean),
        notCallAt: this.filterForm.notCallAt.filter(Boolean),
        appointmentAt: this.filterForm.appointmentAt.filter(Boolean),
        store: this.filterForm.store,
        childName: _.trim(this.filterForm.childName),
        importUpdatedAt: this.filterForm.importUpdatedAt.filter(Boolean),
        numberOfCall: this.filterForm.numberOfCall,
        typeNumberOfCall: this.filterForm.typeNumberOfCall,
        boughtProduct: this.filterForm.boughtProduct,
        unBoughtProduct: this.filterForm.unBoughtProduct,
        customerResult: this.filterForm.customerResult,
        typeOrderTotalPrice: this.filterForm.typeOrderTotalPrice,
        expiredDate: this.filterForm.expiredDate,
        orderCreatedAt: this.filterForm.orderCreatedAt,
        orderTotalPrice: this.filterForm.orderTotalPrice,
        neAssignedAt: this.filterForm.neAssignedAt,
        typeCumulativePoint: this.filterForm.typeCumulativePoint,
        cumulativePoint: this.filterForm.cumulativePoint,
        // schoolLevelId: this.$store.state.module.schoolLevelId,
        assignedAtHistory: this.filterForm.assignedAtHistory,
        orderSuccessDate: this.filterForm.orderSuccessDate,
        orderStatus: this.filterForm.orderStatus,
        tinhId: this.filterForm.tinhId,
        huyenId: this.filterForm.huyenId,
        schoolName: this.filterForm.schoolName,
        isContacted: this.filterForm.isContacted,
        contactedAt: this.filterForm.contactedAt.filter(Boolean),
        typeId: this.$store.state.module.typeId ? this.$store.state.module.typeId
                : this.filterForm.typeId,
        trialStatus: this.filterForm.trialStatus,
        schoolLevelId: this.$store.state.module.schoolLevelId ? this.$store.state.module.schoolLevelId
          : this.filterForm.schoolLevelId,
        connectedSocial:this.filterForm.socialValue,
        soLoi: this.filterForm.soLoi,
        orderCreatedBy:
          this.filterForm.orderCreatedBy.filter(userItem => userItem.hasOwnProperty('userId')).map(itemMap => itemMap.userId),
        appointmentTestStartTime:this.filterForm.appointmentTestTime ? this.filterForm.appointmentTestTime[0] : null,
        appointmentTestEndTime:this.filterForm.appointmentTestTime ? this.filterForm.appointmentTestTime[1] : null,
        appointmentInterviewStartTime:this.filterForm.appointmentInterviewTime ? this.filterForm.appointmentInterviewTime[0] : null,
        appointmentInterviewEndTime:this.filterForm.appointmentInterviewTime ? this.filterForm.appointmentInterviewTime[1] : null,
        testResultStartTime:this.filterForm.testResultTime ? this.filterForm.testResultTime[0] : null,
        testResultEndTime:this.filterForm.testResultTime ? this.filterForm.testResultTime[1] : null,
        trialDate: this.filterForm.trialDate.filter(Boolean),
        subjectId:this.filterForm.subjectTest || null,
        cumulativePointMonthYear: {
          month: this.filterForm.monthPicker && moment(this.filterForm.monthPicker).format('MM') || null,
          year: this.filterForm.monthPicker && moment(this.filterForm.monthPicker).format('YYYY') || null,
          type: this.filterForm.compare,
          point: this.filterForm.inputPointCumulated || null
        },
        birthdayDescription: this.filterForm.birthdayDescription,
        activeCodes: this.filterForm.activeCodes,
        hasActiveCode: this.filterForm.hasActiveCode,
        isRegistedCapacity: this.filterForm.isRegistedCapacity,
        tags: this.filterForm.tags,
        zuid: this.filterForm.zuid,
        statusTrial: this.filterForm.statusTrial.filter(Boolean),
        typeNumberOfLearnTrial: this.filterForm.typeNumberOfLearnTrial,
        numberOfLearnTrial: this.filterForm.numberOfLearnTrial,
        codeSource: this.filterForm.codeSource,
        productDescription : this.filterForm.productDescription,
        segmentId: this.filterForm.segmentId,
        position: this.filterForm.position
      };
      if (!this.filterForm.monthPicker && !this.filterForm.inputPointCumulated){
        delete params.cumulativePointMonthYear
      }
      if (params.userIds.includes(-1)) {
        params.userId = 'no_user';
      }

      // console.log('count contact: ', params);
      const [response, responseContactStatus] = await Promise.all([
        ContactStatusRepository.countTotalContact(params),
        ContactStatusRepository.contactStatusAddon()
      ])
      const statusIds = responseContactStatus.data?.map(s => s.contactStatusId);
      this.mapContactStatusIdCanCall = statusIds.reduce((acc, num) => {
        acc[num] = true;
        return acc;
      }, {});
      console.log(this.mapContactStatusIdCanCall, "mapContactStatusIdCanCall")
      // loading.hide();
      this.appLoadingData(false)
      this.totalContactStatus = 0;
      if (response.success) {
        const typeHeaderContactStatus = [];
        const contactStatusList = [];
        const typeExpand = typeContactExpand;
        let statusFirstTypeExpand = false;
        let notInTypeList = [];
        if (!this.isManager() && !this.checkAuthorization('view-store-new-contact_read')) {
          notInTypeList = ['T0', 'C0', 'G0'];
        }
        for (let contactStatus of _.get(response, 'data', [])) {
          if (notInTypeList.includes(contactStatus?.type?.slice(-2))) {
            continue;
          }
          typeHeaderContactStatus.push({
            name: !this.$store.state.module.typeId ? contactStatus.type : contactStatus.type.slice(-2),
            colspan: _.get(contactStatus, 'data', []).length || 1,
            statusFirstTypeExpand: typeExpand.includes(contactStatus?.type?.slice(-2)) && !statusFirstTypeExpand,
            type: contactStatus.type
          });
          // let statusFirstTypeExpand = false;
          _.get(contactStatus, 'data', []).forEach(data => {
            contactStatusList.push({
              type: contactStatus.type,
              id: _.get(data, 'id', 0),
              color:
                _.get(data, 'color', contactStatusDefaultColor) ||
                contactStatusDefaultColor,
              noContact: _.get(data, 'noContact', 0),
              name: _.get(data, 'name', 0),
              statusFirstTypeExpand:
                typeExpand.includes(contactStatus?.type?.slice(-2)) &&
                !statusFirstTypeExpand
            });
            if (
              typeExpand.includes(contactStatus?.type?.slice(-2)) &&
              !statusFirstTypeExpand
            ) {
              statusFirstTypeExpand = true;
            }
            this.totalContactStatus += parseInt(_.get(data, 'noContact', 0));
          });
        }
        this.typeHeaderContactStatus = typeHeaderContactStatus;
        this.countContactStatusList = contactStatusList;
      } else {
        const statusCode = _.get(response, 'data.code', 200);
        this.typeHeaderContactStatus = [];
        this.countContactStatusList = [];
        this.totalContactStatus = 0;
      }
    },
    async getContactList() {
      let filterForm = _.cloneDeep(this.filterForm)
      this.arrayCustomerId = []
      const params = {
        limit: this.limit,
        page: this.currentPage - 1,
        keyword: this.filterForm.keyword,
        statusIds: this.filterForm.statusIds.filter(Boolean),
        years: this.filterForm.years.filter(Boolean),
        // userIds: filterForm.userIds.filter(Boolean),
        userIds: filterForm.userIds.filter(userItem => userItem.hasOwnProperty('userId')).map(itemMap => itemMap.userId),
        contactSourceIds: this.filterForm.contactSourceIds.filter(Boolean),
        productGroupIds: this.filterForm.productGroupIds.filter(Boolean),
        assignedAt: this.filterForm.assignedAt.filter(Boolean),
        lastSuccessCallAt: this.filterForm.lastSuccessCallAt.filter(Boolean),
        notCallAt: this.filterForm.notCallAt.filter(Boolean),
        appointmentAt: this.filterForm.appointmentAt.filter(Boolean),
        store: this.filterForm.store,
        childName: _.trim(this.filterForm.childName),
        importUpdatedAt: this.filterForm.importUpdatedAt.filter(Boolean),
        numberOfCall: this.filterForm.numberOfCall,
        typeNumberOfCall: this.filterForm.typeNumberOfCall,
        boughtProduct: this.filterForm.boughtProduct,
        unBoughtProduct: this.filterForm.unBoughtProduct,
        customerResult: this.filterForm.customerResult,
        typeOrderTotalPrice: this.filterForm.typeOrderTotalPrice,
        expiredDate: this.filterForm.expiredDate,
        orderCreatedAt: this.filterForm.orderCreatedAt,
        orderTotalPrice: this.filterForm.orderTotalPrice,
        neAssignedAt: this.filterForm.neAssignedAt,
        typeCumulativePoint: this.filterForm.typeCumulativePoint,
        cumulativePoint: this.filterForm.cumulativePoint,
        // schoolLevelId: this.$store.state.module.schoolLevelId,
        assignedAtHistory: this.filterForm.assignedAtHistory,
        orderSuccessDate: this.filterForm.orderSuccessDate,
        orderStatus: this.filterForm.orderStatus,
        tinhId: this.filterForm.tinhId,
        huyenId: this.filterForm.huyenId,
        schoolName: this.filterForm.schoolName,
        isContacted: this.filterForm.isContacted,
        contactedAt: this.filterForm.contactedAt.filter(Boolean),
        typeId: this.$store.state.module.typeId ? this.$store.state.module.typeId
                : this.filterForm.typeId,
        trialStatus: this.filterForm.trialStatus,
        schoolLevelId: this.$store.state.module.schoolLevelId ? this.$store.state.module.schoolLevelId
          : this.filterForm.schoolLevelId,
        connectedSocial:this.filterForm.socialValue,
        soLoi: this.filterForm.soLoi,
        orderCreatedBy:
          this.filterForm.orderCreatedBy.filter(userItem => userItem.hasOwnProperty('userId')).map(itemMap => itemMap.userId),
        isMainId: this.filterForm.isMainId,
        appointmentTestStartTime:this.filterForm.appointmentTestTime ? this.filterForm.appointmentTestTime[0] : null,
        appointmentTestEndTime:this.filterForm.appointmentTestTime ? this.filterForm.appointmentTestTime[1] : null,
        appointmentInterviewStartTime:this.filterForm.appointmentInterviewTime ? this.filterForm.appointmentInterviewTime[0] : null,
        appointmentInterviewEndTime:this.filterForm.appointmentInterviewTime ? this.filterForm.appointmentInterviewTime[1] : null,
        testResultStartTime:this.filterForm.testResultTime ? this.filterForm.testResultTime[0] : null,
        testResultEndTime:this.filterForm.testResultTime ? this.filterForm.testResultTime[1] : null,
        trialDate: this.filterForm.trialDate.filter(Boolean),
        contactAgency: this.filterForm.contactAgency,
        subjectId:this.filterForm.subjectTest || null,
        //cumulativePointMonthYear: this.filterForm.cumulativePointMonthYear,
        cumulativePointMonthYear: {
          month: this.filterForm.monthPicker && moment(this.filterForm.monthPicker).format('MM'),
          year: this.filterForm.monthPicker && moment(this.filterForm.monthPicker).format('YYYY'),
          type: this.filterForm.compare,
          point: this.filterForm.inputPointCumulated
        },
        birthdayDescription: this.filterForm.birthdayDescription,
        activeCodes: this.filterForm.activeCodes,
        hasActiveCode: this.filterForm.hasActiveCode,
        isRegistedCapacity: this.filterForm.isRegistedCapacity,
        tags: this.filterForm.tags,
        zuid: this.filterForm.zuid,
        statusTrial: this.filterForm.statusTrial.filter(Boolean),
        typeNumberOfLearnTrial: this.filterForm.typeNumberOfLearnTrial,
        numberOfLearnTrial: this.filterForm.numberOfLearnTrial,
        codeSource: this.filterForm.codeSource,
        productDescription : this.filterForm.productDescription,
        segmentId: this.filterForm.segmentId,
        position: this.filterForm.position,
      };
      // if (this.filterForm.typeNumberOfCall == 'Bằng') {
      //   params.numberOfCall = this.filterForm.numberOfCall
      // } else if (this.filterForm.typeNumberOfCall == 'Lớn hơn') {
      //   params['$gt_numberOfCall'] = this.filterForm.numberOfCall
      // } else {
      //   params['$lt_numberOfCall'] = this.filterForm.numberOfCall
      // }
      if (!this.filterForm.monthPicker && !this.filterForm.inputPointCumulated){
        delete params.cumulativePointMonthYear
      }

      if (params.userIds.includes(-1)) {
        params.userId = 'no_user';
      }

      this.filterForm.modalType = '';
      this.filterForm.checkboxAll = false;
      // this.loading = true;
      // const loader = this.$loading.show();
      this.appLoadingData(true)
      const response = await ContactRepository.list(params);
      // this.loading = false;
      this.appLoadingData(false)
      if (response.success) {
        // this.totalItem = _.get(response, 'totalItem', 0)
        let data = await this.mappingContactList(_.get(response, 'data', []));
        // if(this.rowAttributes.findIndex(
        //   attribute => attribute.value && attribute.name == 'studyResult'
        // ) > -1){
        //   this.contacts = data;
        //   this.getStudyResult(data)
        // }
        this.contacts = data.map(item => {
          return {
            ...item,
            timesCall: 0,
            called:false,
          }
        })
        this.contactsClone = _.cloneDeep(this.contacts)
        Bus.$emit('calculate-sticky-contact-table-data')
        if(this.arrayCustomerId.length){
          let resultAccount = await ContactRepository.checkAccountContactNew({
            customerIds:this.arrayCustomerId
          })
          let arrayCheckingAccount = resultAccount.data || [];
        const result = _.map(this.contacts, (itemB) => {
            itemB.childCustomer = _.map(itemB.childCustomer, (customerB) => {
              const matchingCustomer = _.find(arrayCheckingAccount, { id: customerB.id });
              if (matchingCustomer) {
                  return _.assign({}, customerB, {
                      isMainAccount:true,
                      userName: matchingCustomer.userName,
                      order: matchingCustomer.order,
                  });
              }

              return customerB;
          });

          return itemB;
        });
        }
      } else {
        this.contacts = [];
        // this.totalItem = 0;
        const statusCode = _.get(response, 'data.code', STATUS_TOKEN_EXPIRED);
      }

      // loader.hide();
    },
    async mappingContactList(contacts) {
      return await Promise.all( contacts.map( async  contact => {
        let contactTemp = contact;
        let customerUpdateId = contact.id;
        let contactColumnValues = {};
        _.get(contactTemp, 'contactColumnValues', []).forEach(dataAttribute => {
          contactColumnValues[dataAttribute.columnId] = dataAttribute.value;
        });
        _.get(contactTemp, 'contact.contactColumnValues', []).forEach(
          dataAttribute => {
            contactColumnValues[dataAttribute.columnId] = dataAttribute.value;
          }
        );

        if (contactTemp.position === 'child') {
          if (!Array.isArray(contactTemp.contact.customers)) {
            contactTemp.contact.customers = [];
          }
          let contactColumnMain = {};
          _.get(contactTemp, 'contactColumnValues', []).forEach(
            dataAttribute => {
              contactColumnMain[dataAttribute.columnId] = dataAttribute.value;
            }
          );
          contactTemp.contact.position = 'child';
          contactTemp.contact.customers.push({
            id: _.get(contactTemp, 'id', null),
            isMainCustomer: true,
            mobile: _.get(contactTemp, 'mobile', ''),
            position: 'child',
            fullName: contactTemp.fullName,
            capability: _.get(contactTemp, 'capability', ''),
            birthday: _.get(contactTemp, 'birthday', ''),
            birthdayDescription: _.get(contactTemp, 'birthdayDescription', ''),
            productDescription: _.get(contactTemp, 'productDescription', ''),
            ...contactColumnMain
          });
        }
        const { customers = [] } = contact;
        const mainCustomer = customers.find(c => c.isMainCustomer);
        let childCustomer = [];
        let parentCustomer = [];
        _.get(contactTemp, 'customers', []).forEach(customer => {
          const customerTemp = customer;
          customerTemp.phones = _.get(customerTemp, 'phones', []).map(
            data => data.phoneNumber
          );
          if (!_.get(customer, 'isMainCustomer', false)) {
            if (!Array.isArray(customerTemp.phones)) {
              customerTemp.phones = [];
            }
            customerTemp.mobile = _.get(customerTemp, 'phones[0]', '');
          }
          _.get(customerTemp, 'contactColumnValues', []).forEach(
            dataAttribute => {
              customerTemp[dataAttribute.columnId] = dataAttribute.value;
            }
          );
          customerTemp.editId = _.get(customerTemp, 'id', null),
          customerTemp.editAttrs = {
            childFullName: false,
            mobile: false,
            birthday: false,
            birthdayDescription: false,
            productDescription: false,
            capability: false,
            email: false,
            fullName: false,
            detailAddress: false,
            contactSourcesList: false,
            userFullName: false,
            description: false
          };
          if (customer.position !== 'child') {
            parentCustomer.push(customerTemp);
          } else {
            childCustomer.push({
              ...customerTemp,
              performance: '',
              studyResult: [],
              statusResultName: (customerTemp.statusResult == 'KHONGHOC' && !parseInt(contactTemp.order.totalOrder)) ? '' : this.listStudyResult[customerTemp.statusResult]
            });
          }
        });

        const contactSources = _.get(contact, 'contactSources', [])
          .map(contactSource => _.hasIn(contactSource, 'name') ? contactSource.name : null)
          .join(', ');

        const groups = _.get(contact, 'groups', [])
          .map(groups => _.hasIn(groups, 'name') ? groups.name : null)
          .join(', ');
        if(!childCustomer.length){
          childCustomer.push({
            id: null,
            editId: _.get(contact, 'id', null),
            childFullName: '',
            mobile: '',
            birthday: '',
            birthdayDescription: '',
            productDescription: '',
            capability: '',
            email: '',
            fullName: '',
            detailAddress: '',
            contactSourcesList: [],
            userList: [],
            editAttrs: {
              childFullName: false,
              mobile: false,
              birthday: false,
              birthdayDescription: false,
              productDescription: false,
              capability: false,
              email: false,
              fullName: false,
              detailAddress: false,
              contactSourcesList: false,
              userFullName: false,
              description: false,
              performance: '',
              studyResult: []
            }
          });
        }
        let customerIds = contactTemp.customers.map(customer => {
          return customer.id
        })
        this.arrayCustomerId = [...this.arrayCustomerId, ...customerIds]
        return {
          callingStatus: '',
          checkbox: false,
          id: contactTemp.id,
          code: _.get(contactTemp, 'code', ''),
          contactSources,
          groups,
          cumulativePoint: contactTemp.cumulativePoint ?? '',
          statusId: _.get(contactTemp, 'statusId', null),
          contactStatus: _.get(contactTemp, 'contactStatus', {}),
          description: _.get(contactTemp, 'description', ''), // ghi chu
          mobile: _.get(mainCustomer, 'mobile', ''),
          rowspan: childCustomer.length === 0 ? 1 : childCustomer.length,
          childCustomer,
          detailAddress: _.trim(_.get(mainCustomer, 'detailAddress', '')),
          user: _.get(contactTemp, 'user', {}),
          assignedAt: _.get(contactTemp, 'assignedAt', ''),
          importUpdatedAt: _.get(contactTemp, 'importUpdatedAt', ''),
          userMarketingName: _.get(contactTemp, 'userMarketingName', ''),
          // userMarketingName: 'data test 3',
          historyOrder:
            _.get(contactTemp, 'order.totalOrder', 0) == 0 ? 'Không' : 'Có',
          ...(_.get(mainCustomer, 'position', '') !== 'child'
            ? {
                email: _.get(mainCustomer, 'email', ''),
                fullName: _.get(mainCustomer, 'fullName', '')
              }
            : {
                email: _.get(parentCustomer, '[0].email', ''),
                fullName: _.get(parentCustomer, '[0].fullName', '')
              }),
          contactFullName: _.get(mainCustomer, 'fullName', ''),
          contactSourcesList: _.get(contactTemp, 'contactSources', []),
          customers: _.get(contactTemp, 'contact.customers', []),
          customerUpdateId,
          createdBy: _.get(contactTemp, 'contact.createdBy', 1),
          userFullName: _.get(contactTemp, 'contact.user.fullName', ""),
          mainCustomerId: _.get(mainCustomer, 'id', null),
          lastExamAt: _.get(contactTemp, 'lastExamAt', null),
          numberOfCall: _.get(contactTemp, 'numberOfCall', ''),
          numberOfCallC: _.get(contactTemp, 'numberOfCallC', ''),
          numberOfCallG: _.get(contactTemp, 'numberOfCallG', ''),
          appointments: _.get(contactTemp, 'appointments', ''),
          contactType: _.get(contactTemp, 'contactType', ''),
          phoneRelated: _.get(contactTemp, 'phoneRelated', ''),
          mainId: _.get(contactTemp, 'mainId', ''),
          order: _.get(contactTemp, 'order', {}),
          schoolLevels: _.get(contactTemp, 'schoolLevels', {}),
          schoolLevelId: _.get(contactTemp, 'schoolLevelId', ''),
          trialStatus: _.get(contactTemp, 'trialStatus', ''),
          types: _.get(contactTemp, 'types', {}),
          typeId: _.get(contactTemp, 'typeId', ''),
          zuid:_.get(contactTemp,'zuid',''),
          capacityAssessmentAt: _.get(contactTemp, 'capacityAssessmentAt', ''),
          numberOfLearnTrial: _.get(contactTemp, 'numberOfLearnTrial', ''),
        };
      }));
    },
    applyPendingPage: _.debounce(function() {
        this.currentPage = parseInt(this.pendingPage)
        return
    }, 500),

    showContactsIndex() {
      if(this.contacts.length > 0) {
        let maxIndex = parseInt(this.currentPage)*parseInt(this.limit)
        return (maxIndex - parseInt(this.limit) + 1) + ' - ' + maxIndex
      }else {
        return ('0 - 0')
      }
    },
    async getStudyResult(data) {

      for (let i = 0; i < this.contacts.length; i++) {
        if(!_.isEmpty(this.contacts[i].order) && parseInt(this.contacts[i].order.totalOrder)) {
          // let childCustomer = this.contacts[i].childCustomer
          for (let j = 0; j < this.contacts[i].childCustomer.length; j++) {
            this.contacts[i].childCustomer[j]['isLoading'] = true;
          }
        }
      }

      let contacts = _.cloneDeep(data)
      for (let i = 0; i < contacts.length; i++) {
        let childCustomer = contacts[i].childCustomer
        if(!_.isEmpty(contacts[i].order) && parseInt(contacts[i].order.totalOrder)) {
          for (let j = 0; j < childCustomer.length; j++) {
            childCustomer[j]['isLoading'] = true;
            let params = {
              fullName: childCustomer[j].fullName,
              user_id: childCustomer[j].vhUserId ?? null
            }
            let res = await ContactRepository.getResultStudy(childCustomer[j].contactId, params);
            childCustomer[j]['isLoading'] = false;
            if (res.success && _.isArray(res.data) && res.data.length) {
              childCustomer[j]['performance'] = 'Phức tạp';
              childCustomer[j]['study_result'] = _.get(res, 'data[0].study_result', []);
              childCustomer[j]['study_result_multiple'] = _.get(res, 'data', []);
            } else if(res.success) {
              childCustomer[j]['performance'] = _.get(res, 'data.performance', '');
              childCustomer[j]['study_result'] = _.get(res, 'data.study_result', []);
              childCustomer[j]['user_id'] = _.get(res, 'data.user_id', '');
              // this.contacts[i].childCustomer = childCustomer
            }
          }
        }

        contacts[i].childCustomer = childCustomer
      }

      this.contacts = contacts
    },
     async getProductList() {
      const res = await ProductRepository.list({limit: 1000})
      if (res.success) {
        let groupBy = _.groupBy( _.get(res, 'data', []), 'status');
        console.log(groupBy, "groupBy")
        this.productList = [
          {header: "Sản phẩm ACTIVE"},
          ..._.get(groupBy, 'active', []),
          ..._.get(groupBy, 'draft', []),
          {header: "Sản phẩm INACTIVE"},
          ..._.get(groupBy, 'inactive', []),
        ]
      } else {
        this.productList = []
      }
    },
    async getListSchoolLevel() {
      if(this.$store.state.listSchoolLevelDrawer) {
        this.schoolLevelList = _.cloneDeep(this.$store.state.listSchoolLevelDrawer)
        return
      }

      this.appLoadingData(true)
      const res = await SchoolLevelRepository.listTypeSchoolLevel()
      if (res.success) {
        this.schoolLevelList = _.get(res, 'data', [])
        this.$store.dispatch('SET_LIST_SCHOOL_LEVEL_DRAWER', this.schoolLevelList)
      } else {
        this.schoolLevelList = []
      }

      this.appLoadingData(false)
    },
    async getListSchoolLevelFilter() {
      this.appLoadingData(true)
      const res = await SchoolLevelRepository.list()
      if (res.success) {
        this.schoolLevelListFilter = _.get(res, 'data', [])
        this.schoolLevelListFilter.unshift({
          id: 0,
          name: 'Không có nhóm ngành'
        })
      } else {
        this.schoolLevelListFilter = []
      }

      this.appLoadingData(false)
    },
    async getListProvince() {
      // const params = {}
      const res = await AddressRepository.provinces({limit: 1000})
      if (res.success) {
        this.provinceList = _.get(res, 'data', [])
      } else {
        this.provinceList = []
      }
    },
    async getListMinistryTree() {
      // const loader = this.$loading.show();
      this.appLoadingData(true)
      const respond = await OrganizationMachineRepository.listMinistryUserTree({
        schoolLevelId: this.$store.state.module.schoolLevelId,
        typeId: this.$store.state.module.typeId
      });
      // loader.hide();
      this.appLoadingData(false)
      if (_.get(respond, 'success', false)) {
        this.ministries[0].children = _.get(respond, 'data', []);
        // this.open.push(this.ministries[0])
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(respond, 'message', ''),
        })
      }
    },
    async getCountContactModuleList() {
      // const loading = this.$loading.show();
      if (!this.showModuleTable) {
        return
      }
      this.appLoadingData(true)
      let filterForm = _.cloneDeep(this.filterForm)
      const params = {
        limit: this.limit,
        page: this.currentPage - 1,
        keyword: this.filterForm.keyword,
        statusIds: this.filterForm.statusIds.filter(Boolean),
        years: this.filterForm.years.filter(Boolean),
        // userIds: filterForm.userIds.filter(Boolean),
        userIds: filterForm.userIds.filter(userItem => userItem.hasOwnProperty('userId')).map(itemMap => itemMap.userId),
        contactSourceIds: this.filterForm.contactSourceIds.filter(Boolean),
        productGroupIds: this.filterForm.productGroupIds.filter(Boolean),
        assignedAt: this.filterForm.assignedAt.filter(Boolean),
        lastSuccessCallAt: this.filterForm.lastSuccessCallAt.filter(Boolean),
        notCallAt: this.filterForm.notCallAt.filter(Boolean),
        appointmentAt: this.filterForm.appointmentAt.filter(Boolean),
        store: this.filterForm.store,
        childName: _.trim(this.filterForm.childName),
        importUpdatedAt: this.filterForm.importUpdatedAt.filter(Boolean),
        numberOfCall: this.filterForm.numberOfCall,
        typeNumberOfCall: this.filterForm.typeNumberOfCall,
        boughtProduct: this.filterForm.boughtProduct,
        unBoughtProduct: this.filterForm.unBoughtProduct,
        customerResult: this.filterForm.customerResult,
        typeOrderTotalPrice: this.filterForm.typeOrderTotalPrice,
        expiredDate: this.filterForm.expiredDate,
        orderCreatedAt: this.filterForm.orderCreatedAt,
        orderTotalPrice: this.filterForm.orderTotalPrice,
        neAssignedAt: this.filterForm.neAssignedAt,
        typeCumulativePoint: this.filterForm.typeCumulativePoint,
        cumulativePoint: this.filterForm.cumulativePoint,
        // schoolLevelId: this.$store.state.module.schoolLevelId,
        assignedAtHistory: this.filterForm.assignedAtHistory,
        orderSuccessDate: this.filterForm.orderSuccessDate,
        orderStatus: this.filterForm.orderStatus,
        tinhId: this.filterForm.tinhId,
        huyenId: this.filterForm.huyenId,
        schoolName: this.filterForm.schoolName,
        isContacted: this.filterForm.isContacted,
        contactedAt: this.filterForm.contactedAt.filter(Boolean),
        // typeId: this.$store.state.module.typeId ? this.$store.state.module.typeId
        //     : this.filterForm.typeId,
        trialStatus: this.filterForm.trialStatus,
        // schoolLevelId: this.$store.state.module.schoolLevelId ? this.$store.state.module.schoolLevelId
        //         : this.filterForm.schoolLevelId,
        connectedSocial:this.filterForm.socialValue,
        orderCreatedBy:
          this.filterForm.orderCreatedBy.filter(userItem => userItem.hasOwnProperty('userId')).map(itemMap => itemMap.userId),
        appointmentTestStartTime:this.filterForm.appointmentTestTime ? this.filterForm.appointmentTestTime[0] : null,
        appointmentTestEndTime:this.filterForm.appointmentTestTime ? this.filterForm.appointmentTestTime[1] : null,
        appointmentInterviewStartTime:this.filterForm.appointmentInterviewTime ? this.filterForm.appointmentInterviewTime[0] : null,
        appointmentInterviewEndTime:this.filterForm.appointmentInterviewTime ? this.filterForm.appointmentInterviewTime[1] : null,
        testResultStartTime:this.filterForm.testResultTime ? this.filterForm.testResultTime[0] : null,
        testResultEndTime:this.filterForm.testResultTime ? this.filterForm.testResultTime[1] : null,
        trialDate: this.filterForm.trialDate.filter(Boolean),
        subjectId:this.filterForm.subjectTest || null,
        cumulativePointMonthYear: {
          month: this.filterForm.monthPicker && moment(this.filterForm.monthPicker).format('MM'),
          year: this.filterForm.monthPicker && moment(this.filterForm.monthPicker).format('YYYY'),
          type: this.filterForm.compare,
          point: this.filterForm.inputPointCumulated
        },
        birthdayDescription: this.filterForm.birthdayDescription,
        activeCodes: this.filterForm.activeCodes,
        hasActiveCode: this.filterForm.hasActiveCode,
        isRegistedCapacity: this.filterForm.isRegistedCapacity,
        tags: this.filterForm.tags,
        zuid: this.filterForm.zuid,
        statusTrial: this.filterForm.statusTrial.filter(Boolean),
        typeNumberOfLearnTrial: this.filterForm.typeNumberOfLearnTrial,
        numberOfLearnTrial: this.filterForm.numberOfLearnTrial,
        position: this.filterForm.position,
      };
      if (!this.filterForm.monthPicker && !this.filterForm.inputPointCumulated){
        delete params.cumulativePointMonthYear
      }
      if (params.userIds.includes(-1)) {
        params.userId = 'no_user';
      }

      let response = '';
      if(this.isShowModule && this.showModuleTable) {
        response = await ContactStatusRepository.countTotalContactModule(params);
      }
      this.appLoadingData(false)
      if (response.success) {
        this.totalContactModule = 0;
        const typeHeaderContactModule = [];
        const contactModuleList = [];
        for (let contactModule of _.get(response, 'data', [])) {
          typeHeaderContactModule.push({
            name: contactModule.type,
            colspan: _.get(contactModule, 'data', []).length || 1,
            code: _.get(contactModule, 'code', null),
            typeId: _.get(contactModule, 'data', []).length ? contactModule.data[0].typeId : null,
            schoolLevelId: null
          });
          if(_.isArray(contactModule.data)) {
            _.get(contactModule, 'data', []).forEach(data => {
              contactModuleList.push({
                type: contactModule.type,
                id: _.get(data, 'schoolLevelId', null),
                noContact: _.get(data, 'noContact', 0),
                name: _.get(data, 'name', 0),
                typeId: _.get(data, 'typeId', null),
                schoolLevelId: _.get(data, 'schoolLevelId', null)
              });

              this.totalContactModule += _.get(data, 'noContact', 0);
            });
          } else {
            contactModuleList.push({
              name: contactModule.type,
              code: _.get(contactModule, 'code', 'SL'),
              noContact: _.get(contactModule, 'data', 0),
              typeId: null,
              schoolLevelId: null
            });
            if(_.get(contactModule, 'code', null) == 'SĐL') {
              this.totalContactModule += _.get(contactModule, 'data', 0)
            }
          }
        }
        this.typeHeaderContactModule = typeHeaderContactModule;
        this.countContactModuleList = contactModuleList;
      } else {
        this.typeHeaderContactModule = [];
        this.countContactModuleList = [];
        this.totalContactModule = 0;
      }
    },
    showModule() {
      this.showModuleTable = !this.showModuleTable;
      if(this.showStatus) {
        this.showStatus = false;
      }
      if(this.showModuleTable && _.isEmpty(this.typeHeaderContactModule)) {
        this.getCountContactModuleList();
      }
    }
  },
  watch: {
    currentPage: {
      handler() {
        this.getContactList();
      }
    },
    limit: {
      handler() {
        if (this.currentPage === 1) {
          this.getContactList();
        } else {
          this.currentPage = 1;
          this.pendingPage = 1;
        }
      }
    }
  }
};
</script>
<style scoped>
#contact-list {
  padding-bottom: 0px;
}
/deep/.v-expansion-panel::before {
  box-shadow: none;
}
/deep/.c-pagination .v-pagination__navigation {
  height: 28px;
  width: 28px;
}
/deep/.c-pagination .v-pagination__item {
  height: 28px;
  min-width: 28px;
  font-size: 12px;
}
.lines-displayed {
  min-height: auto;
}
.lines-displayed .item-lines-displayed {
  width: 100%;
  padding: 8px 15px;
  margin: 4px 0px;
  cursor: pointer;
}
.lines-displayed .item-lines-displayed:hover {
  background: #d2d2d2;
}
/deep/.filter-store input {
  font-size: 13px !important;
}
/deep/.report-achievement .v-expansion-panel-content__wrap {
  padding: 0;
}

.pagination-btn-left, .pagination-btn-right {
  max-width: 30px !important;
  min-width: 30px !important;
  background-color: #ffffff !important;
}
.pagination-btn-left i, .pagination-btn-right i {
  color: rgba(0,0,0,.54) !important
}
.pagination-btn-left {
  margin: 0px 5px 2px 10px !important;
}
.pagination-btn-right {
  margin: 0px 10px 2px 5px !important;
}
/deep/.panel-no-pb .v-expansion-panel-content__wrap {
  padding-bottom: 0px;
}
/deep/.v-expansion-panel-content .v-expansion-panel-content__wrap {
  padding-left: 15px;
  padding-right: 15px;
}
/deep/.s-table-contact.v-expansion-panel-content .v-expansion-panel-content__wrap {
  padding-left: 15px;
  padding-right: 15px;
  padding-bottom: 0px;
}
</style>
<style scoped lang="scss">
.auto-call-popup{
  width: 117px;
  height: 55px;
  background: #F0F0F0;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  position: fixed;
  top: 86px;
  left: 520px;
  z-index: 1;
  padding: 11px 20px 11px 20px;
  display: flex;
  justify-content: space-between;
  .auto-call-button {
    padding-top: 4px;
    width: 30px !important;
    text-align: center;
    height: 30px !important;
    border-radius: 15px;
    cursor: pointer;
    i{
      color: #FFFFFF;
    }
  }
}
</style>
